import React from "react";
import "../../components/Banner/Banner.css";
import styled from "styled-components";

function Banner(movie) {
	console.log(movie, "banner js");

	const Info = styled.span`
		display: inline-block;
		font-size: 15px;
		font-weight: 500;
		margin-right: 10px;
	`;

	const Language = styled.span`
		display: inline-block;
		font-size: 13px;
		font-weight: 500;
		margin-right: 10px;
		border: 1px solid #fff;
		padding: 0 3px 1px 1px;
		text-transform: uppercase;
	`;

	const Network = styled.div`
		display: flex;
		align-items: center;

		img {
			max-width: 120px;
			margin-right: 15px;
		}
	`;

	const Genres = styled.p`
		font-size: 14px;
		color: #a7a7a7;
		font-weight: 500;

		span {
			display: inline-block;
			padding-left: 10px;
			color: white;

			&:after {
				content: "-";
				position: relative;
				left: 5px;
			}
			&:last-child {
				&:after {
					content: none;
				}
			}
		}
	`;

	const handleLanguage = (movie) => {
		if (movie.movie.original_language) {
			return <Language>{movie.movie.original_language}</Language>;
		} else {
			movie.movie.languages?.map((language) => {
				return <Language>{language}</Language>;
			});
		}
	};

	const handleDate = (movie) => {
		if (movie.movie.first_air_date) {
			return <Info>{movie.movie.first_air_date?.split("-")[0]}</Info>;
		} else {
			return <Info>{movie.movie.release_date?.split("-")[0]}</Info>;
		}
	};

	const handleTime = (movie) => {
		const time = movie.movie?.runtime;

		if (time) {
			const hours = Math.floor(time / 60);
			const minutes = time % 60;

			return (
				<Info>
					{hours}h {minutes}m
				</Info>
			);
		}
	};

	return (
		<div
			className="banner banner-movie"
			style={{
				backgroundSize: "cover",
				backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie.movie?.backdrop_path}")`,
				backgroundPosition: "center center",
			}}
		>
			<div className="banner__contents">
				<Network className="network_logo mb-10">
					{movie.movie.networks?.map((network) => (
						<img
							key={network?.id}
							src={`https://image.tmdb.org/t/p/original/${network?.logo_path}`}
							alt={network?.name}
						/>
					))}
					{/* {movie.movie.networks.map((network) => (
						<img
							src={`https://image.tmdb.org/t/p/original/${network?.logo_path}`}
							alt=""
						/>
					))} */}
				</Network>
				<h1 className="banner__title">
					{movie.movie.title ||
						movie.movie?.name ||
						movie.movie?.original_name}
				</h1>
				<h1 className="banner__description">{movie.movie?.overview}</h1>
				<div className="d-flex mb-10">
					{handleDate(movie)}
					{handleLanguage(movie)}
					{handleTime(movie)}
					{movie.movie.number_of_episodes && (
						<Info>{movie.movie.number_of_episodes} Episodes</Info>
					)}
					{movie.movie.number_of_seasons && (
						<Info>{movie.movie.number_of_seasons} Seasons</Info>
					)}
				</div>

				<Genres className="banner__genres mb-10">
					Genres:
					{movie.movie.genres?.map((genre) => (
						<span key={genre?.id}>{genre?.name}</span>
					))}
				</Genres>
				<Genres className="banner__genres">
					Status:
					<span>{movie.movie.status}</span>
				</Genres>
				<div className="banner__buttons">
					{/* <button className="banner__button">Play</button> */}
					{/* <button className="banner__button">My List</button> */}
				</div>
			</div>
			<div className="banner--fadeBottom" />
		</div>
	);
}

export default Banner;
